// extracted by mini-css-extract-plugin
export var container = "_35-0";
export var icon = "_35-1";